/*
 RequireJS 2.1.15 Copyright (c) 2010-2014, The Dojo Foundation All Rights Reserved.
 Available via the MIT or new BSD license.
 see: http://github.com/jrburke/requirejs for details
*/
var requirejs, require, define;
(function (ba) {
  function G(b) {
    return "[object Function]" === K.call(b);
  }
  function H(b) {
    return "[object Array]" === K.call(b);
  }
  function v(b, c) {
    if (b) {
      var d;
      for (d = 0; d < b.length && (!b[d] || !c(b[d], d, b)); d += 1);
    }
  }
  function T(b, c) {
    if (b) {
      var d;
      for (d = b.length - 1; -1 < d && (!b[d] || !c(b[d], d, b)); d -= 1);
    }
  }
  function t(b, c) {
    return fa.call(b, c);
  }
  function m(b, c) {
    return t(b, c) && b[c];
  }
  function B(b, c) {
    for (var d in b) if (t(b, d) && c(b[d], d)) break;
  }
  function U(b, c, d, e) {
    c &&
      B(c, function (c, g) {
        if (d || !t(b, g))
          e &&
          "object" === typeof c &&
          c &&
          !H(c) &&
          !G(c) &&
          !(c instanceof RegExp)
            ? (b[g] || (b[g] = {}), U(b[g], c, d, e))
            : (b[g] = c);
      });
    return b;
  }
  function u(b, c) {
    return function () {
      return c.apply(b, arguments);
    };
  }
  function ca(b) {
    throw b;
  }
  function da(b) {
    if (!b) return b;
    var c = ba;
    v(b.split("."), function (b) {
      c = c[b];
    });
    return c;
  }
  function C(b, c, d, e) {
    c = Error(c + "\nhttp://requirejs.org/docs/errors.html#" + b);
    c.requireType = b;
    c.requireModules = e;
    d && (c.originalError = d);
    return c;
  }
  function ga(b) {
    function c(a, k, b) {
      var f,
        l,
        c,
        d,
        e,
        g,
        i,
        p,
        k = k && k.split("/"),
        h = j.map,
        n = h && h["*"];
      if (a) {
        a = a.split("/");
        l = a.length - 1;
        j.nodeIdCompat && Q.test(a[l]) && (a[l] = a[l].replace(Q, ""));
        "." === a[0].charAt(0) &&
          k &&
          ((l = k.slice(0, k.length - 1)), (a = l.concat(a)));
        l = a;
        for (c = 0; c < l.length; c++)
          if (((d = l[c]), "." === d)) l.splice(c, 1), (c -= 1);
          else if (
            ".." === d &&
            !(0 === c || (1 == c && ".." === l[2]) || ".." === l[c - 1]) &&
            0 < c
          )
            l.splice(c - 1, 2), (c -= 2);
        a = a.join("/");
      }
      if (b && h && (k || n)) {
        l = a.split("/");
        c = l.length;
        a: for (; 0 < c; c -= 1) {
          e = l.slice(0, c).join("/");
          if (k)
            for (d = k.length; 0 < d; d -= 1)
              if ((b = m(h, k.slice(0, d).join("/"))))
                if ((b = m(b, e))) {
                  f = b;
                  g = c;
                  break a;
                }
          !i && n && m(n, e) && ((i = m(n, e)), (p = c));
        }
        !f && i && ((f = i), (g = p));
        f && (l.splice(0, g, f), (a = l.join("/")));
      }
      return (f = m(j.pkgs, a)) ? f : a;
    }
    function d(a) {
      z &&
        v(document.getElementsByTagName("script"), function (k) {
          if (
            k.getAttribute("data-requiremodule") === a &&
            k.getAttribute("data-requirecontext") === i.contextName
          )
            return k.parentNode.removeChild(k), !0;
        });
    }
    function e(a) {
      var k = m(j.paths, a);
      if (k && H(k) && 1 < k.length)
        return (
          k.shift(),
          i.require.undef(a),
          i.makeRequire(null, { skipMap: !0 })([a]),
          !0
        );
    }
    function n(a) {
      var k,
        c = a ? a.indexOf("!") : -1;
      -1 < c && ((k = a.substring(0, c)), (a = a.substring(c + 1, a.length)));
      return [k, a];
    }
    function p(a, k, b, f) {
      var l,
        d,
        e = null,
        g = k ? k.name : null,
        j = a,
        p = !0,
        h = "";
      a || ((p = !1), (a = "_@r" + (K += 1)));
      a = n(a);
      e = a[0];
      a = a[1];
      e && ((e = c(e, g, f)), (d = m(r, e)));
      a &&
        (e
          ? (h =
              d && d.normalize
                ? d.normalize(a, function (a) {
                    return c(a, g, f);
                  })
                : -1 === a.indexOf("!")
                ? c(a, g, f)
                : a)
          : ((h = c(a, g, f)),
            (a = n(h)),
            (e = a[0]),
            (h = a[1]),
            (b = !0),
            (l = i.nameToUrl(h))));
      b = e && !d && !b ? "_unnormalized" + (O += 1) : "";
      return {
        prefix: e,
        name: h,
        parentMap: k,
        unnormalized: !!b,
        url: l,
        originalName: j,
        isDefine: p,
        id: (e ? e + "!" + h : h) + b,
      };
    }
    function s(a) {
      var k = a.id,
        b = m(h, k);
      b || (b = h[k] = new i.Module(a));
      return b;
    }
    function q(a, k, b) {
      var f = a.id,
        c = m(h, f);
      if (t(r, f) && (!c || c.defineEmitComplete)) "defined" === k && b(r[f]);
      else if (((c = s(a)), c.error && "error" === k)) b(c.error);
      else c.on(k, b);
    }
    function w(a, b) {
      var c = a.requireModules,
        f = !1;
      if (b) b(a);
      else if (
        (v(c, function (b) {
          if ((b = m(h, b)))
            (b.error = a), b.events.error && ((f = !0), b.emit("error", a));
        }),
        !f)
      )
        g.onError(a);
    }
    function x() {
      R.length && (ha.apply(A, [A.length, 0].concat(R)), (R = []));
    }
    function y(a) {
      delete h[a];
      delete V[a];
    }
    function F(a, b, c) {
      var f = a.map.id;
      a.error
        ? a.emit("error", a.error)
        : ((b[f] = !0),
          v(a.depMaps, function (f, d) {
            var e = f.id,
              g = m(h, e);
            g &&
              !a.depMatched[d] &&
              !c[e] &&
              (m(b, e) ? (a.defineDep(d, r[e]), a.check()) : F(g, b, c));
          }),
          (c[f] = !0));
    }
    function D() {
      var a,
        b,
        c = (a = 1e3 * j.waitSeconds) && i.startTime + a < new Date().getTime(),
        f = [],
        l = [],
        g = !1,
        h = !0;
      if (!W) {
        W = !0;
        B(V, function (a) {
          var i = a.map,
            j = i.id;
          if (a.enabled && (i.isDefine || l.push(a), !a.error))
            if (!a.inited && c) e(j) ? (g = b = !0) : (f.push(j), d(j));
            else if (
              !a.inited &&
              a.fetched &&
              i.isDefine &&
              ((g = !0), !i.prefix)
            )
              return (h = !1);
        });
        if (c && f.length)
          return (
            (a = C("timeout", "Load timeout for modules: " + f, null, f)),
            (a.contextName = i.contextName),
            w(a)
          );
        h &&
          v(l, function (a) {
            F(a, {}, {});
          });
        if ((!c || b) && g)
          if ((z || ea) && !X)
            X = setTimeout(function () {
              X = 0;
              D();
            }, 50);
        W = !1;
      }
    }
    function E(a) {
      t(r, a[0]) || s(p(a[0], null, !0)).init(a[1], a[2]);
    }
    function I(a) {
      var a = a.currentTarget || a.srcElement,
        b = i.onScriptLoad;
      a.detachEvent && !Y
        ? a.detachEvent("onreadystatechange", b)
        : a.removeEventListener("load", b, !1);
      b = i.onScriptError;
      (!a.detachEvent || Y) && a.removeEventListener("error", b, !1);
      return { node: a, id: a && a.getAttribute("data-requiremodule") };
    }
    function J() {
      var a;
      for (x(); A.length; ) {
        a = A.shift();
        if (null === a[0])
          return w(
            C(
              "mismatch",
              "Mismatched anonymous define() module: " + a[a.length - 1]
            )
          );
        E(a);
      }
    }
    var W,
      Z,
      i,
      L,
      X,
      j = {
        waitSeconds: 7,
        baseUrl: "./",
        paths: {},
        bundles: {},
        pkgs: {},
        shim: {},
        config: {},
      },
      h = {},
      V = {},
      $ = {},
      A = [],
      r = {},
      S = {},
      aa = {},
      K = 1,
      O = 1;
    L = {
      require: function (a) {
        return a.require ? a.require : (a.require = i.makeRequire(a.map));
      },
      exports: function (a) {
        a.usingExports = !0;
        if (a.map.isDefine)
          return a.exports
            ? (r[a.map.id] = a.exports)
            : (a.exports = r[a.map.id] = {});
      },
      module: function (a) {
        return a.module
          ? a.module
          : (a.module = {
              id: a.map.id,
              uri: a.map.url,
              config: function () {
                return m(j.config, a.map.id) || {};
              },
              exports: a.exports || (a.exports = {}),
            });
      },
    };
    Z = function (a) {
      this.events = m($, a.id) || {};
      this.map = a;
      this.shim = m(j.shim, a.id);
      this.depExports = [];
      this.depMaps = [];
      this.depMatched = [];
      this.pluginMaps = {};
      this.depCount = 0;
    };
    Z.prototype = {
      init: function (a, b, c, f) {
        f = f || {};
        if (!this.inited) {
          this.factory = b;
          if (c) this.on("error", c);
          else
            this.events.error &&
              (c = u(this, function (a) {
                this.emit("error", a);
              }));
          this.depMaps = a && a.slice(0);
          this.errback = c;
          this.inited = !0;
          this.ignore = f.ignore;
          f.enabled || this.enabled ? this.enable() : this.check();
        }
      },
      defineDep: function (a, b) {
        this.depMatched[a] ||
          ((this.depMatched[a] = !0),
          (this.depCount -= 1),
          (this.depExports[a] = b));
      },
      fetch: function () {
        if (!this.fetched) {
          this.fetched = !0;
          i.startTime = new Date().getTime();
          var a = this.map;
          if (this.shim)
            i.makeRequire(this.map, { enableBuildCallback: !0 })(
              this.shim.deps || [],
              u(this, function () {
                return a.prefix ? this.callPlugin() : this.load();
              })
            );
          else return a.prefix ? this.callPlugin() : this.load();
        }
      },
      load: function () {
        var a = this.map.url;
        S[a] || ((S[a] = !0), i.load(this.map.id, a));
      },
      check: function () {
        if (this.enabled && !this.enabling) {
          var a,
            b,
            c = this.map.id;
          b = this.depExports;
          var f = this.exports,
            l = this.factory;
          if (this.inited)
            if (this.error) this.emit("error", this.error);
            else {
              if (!this.defining) {
                this.defining = !0;
                if (1 > this.depCount && !this.defined) {
                  if (G(l)) {
                    if (
                      (this.events.error && this.map.isDefine) ||
                      g.onError !== ca
                    )
                      try {
                        f = i.execCb(c, l, b, f);
                      } catch (d) {
                        a = d;
                      }
                    else f = i.execCb(c, l, b, f);
                    this.map.isDefine &&
                      void 0 === f &&
                      ((b = this.module)
                        ? (f = b.exports)
                        : this.usingExports && (f = this.exports));
                    if (a)
                      return (
                        (a.requireMap = this.map),
                        (a.requireModules = this.map.isDefine
                          ? [this.map.id]
                          : null),
                        (a.requireType = this.map.isDefine
                          ? "define"
                          : "require"),
                        w((this.error = a))
                      );
                  } else f = l;
                  this.exports = f;
                  if (
                    this.map.isDefine &&
                    !this.ignore &&
                    ((r[c] = f), g.onResourceLoad)
                  )
                    g.onResourceLoad(i, this.map, this.depMaps);
                  y(c);
                  this.defined = !0;
                }
                this.defining = !1;
                this.defined &&
                  !this.defineEmitted &&
                  ((this.defineEmitted = !0),
                  this.emit("defined", this.exports),
                  (this.defineEmitComplete = !0));
              }
            }
          else this.fetch();
        }
      },
      callPlugin: function () {
        var a = this.map,
          b = a.id,
          d = p(a.prefix);
        this.depMaps.push(d);
        q(
          d,
          "defined",
          u(this, function (f) {
            var l, d;
            d = m(aa, this.map.id);
            var e = this.map.name,
              P = this.map.parentMap ? this.map.parentMap.name : null,
              n = i.makeRequire(a.parentMap, {
                enableBuildCallback: !0,
              });
            if (this.map.unnormalized) {
              if (
                (f.normalize &&
                  (e =
                    f.normalize(e, function (a) {
                      return c(a, P, !0);
                    }) || ""),
                (f = p(a.prefix + "!" + e, this.map.parentMap)),
                q(
                  f,
                  "defined",
                  u(this, function (a) {
                    this.init(
                      [],
                      function () {
                        return a;
                      },
                      null,
                      { enabled: !0, ignore: !0 }
                    );
                  })
                ),
                (d = m(h, f.id)))
              ) {
                this.depMaps.push(f);
                if (this.events.error)
                  d.on(
                    "error",
                    u(this, function (a) {
                      this.emit("error", a);
                    })
                  );
                d.enable();
              }
            } else
              d
                ? ((this.map.url = i.nameToUrl(d)), this.load())
                : ((l = u(this, function (a) {
                    this.init(
                      [],
                      function () {
                        return a;
                      },
                      null,
                      { enabled: !0 }
                    );
                  })),
                  (l.error = u(this, function (a) {
                    this.inited = !0;
                    this.error = a;
                    a.requireModules = [b];
                    B(h, function (a) {
                      0 === a.map.id.indexOf(b + "_unnormalized") &&
                        y(a.map.id);
                    });
                    w(a);
                  })),
                  (l.fromText = u(this, function (f, c) {
                    var d = a.name,
                      e = p(d),
                      P = M;
                    c && (f = c);
                    P && (M = !1);
                    s(e);
                    t(j.config, b) && (j.config[d] = j.config[b]);
                    try {
                      g.exec(f);
                    } catch (h) {
                      return w(
                        C(
                          "fromtexteval",
                          "fromText eval for " + b + " failed: " + h,
                          h,
                          [b]
                        )
                      );
                    }
                    P && (M = !0);
                    this.depMaps.push(e);
                    i.completeLoad(d);
                    n([d], l);
                  })),
                  f.load(a.name, n, l, j));
          })
        );
        i.enable(d, this);
        this.pluginMaps[d.id] = d;
      },
      enable: function () {
        V[this.map.id] = this;
        this.enabling = this.enabled = !0;
        v(
          this.depMaps,
          u(this, function (a, b) {
            var c, f;
            if ("string" === typeof a) {
              a = p(
                a,
                this.map.isDefine ? this.map : this.map.parentMap,
                !1,
                !this.skipMap
              );
              this.depMaps[b] = a;
              if ((c = m(L, a.id))) {
                this.depExports[b] = c(this);
                return;
              }
              this.depCount += 1;
              q(
                a,
                "defined",
                u(this, function (a) {
                  this.defineDep(b, a);
                  this.check();
                })
              );
              this.errback && q(a, "error", u(this, this.errback));
            }
            c = a.id;
            f = h[c];
            !t(L, c) && f && !f.enabled && i.enable(a, this);
          })
        );
        B(
          this.pluginMaps,
          u(this, function (a) {
            var b = m(h, a.id);
            b && !b.enabled && i.enable(a, this);
          })
        );
        this.enabling = !1;
        this.check();
      },
      on: function (a, b) {
        var c = this.events[a];
        c || (c = this.events[a] = []);
        c.push(b);
      },
      emit: function (a, b) {
        v(this.events[a], function (a) {
          a(b);
        });
        "error" === a && delete this.events[a];
      },
    };
    i = {
      config: j,
      contextName: b,
      registry: h,
      defined: r,
      urlFetched: S,
      defQueue: A,
      Module: Z,
      makeModuleMap: p,
      nextTick: g.nextTick,
      onError: w,
      configure: function (a) {
        a.baseUrl &&
          "/" !== a.baseUrl.charAt(a.baseUrl.length - 1) &&
          (a.baseUrl += "/");
        var b = j.shim,
          c = { paths: !0, bundles: !0, config: !0, map: !0 };
        B(a, function (a, b) {
          c[b] ? (j[b] || (j[b] = {}), U(j[b], a, !0, !0)) : (j[b] = a);
        });
        a.bundles &&
          B(a.bundles, function (a, b) {
            v(a, function (a) {
              a !== b && (aa[a] = b);
            });
          });
        a.shim &&
          (B(a.shim, function (a, c) {
            H(a) && (a = { deps: a });
            if ((a.exports || a.init) && !a.exportsFn)
              a.exportsFn = i.makeShimExports(a);
            b[c] = a;
          }),
          (j.shim = b));
        a.packages &&
          v(a.packages, function (a) {
            var b,
              a = "string" === typeof a ? { name: a } : a;
            b = a.name;
            a.location && (j.paths[b] = a.location);
            j.pkgs[b] =
              a.name + "/" + (a.main || "main").replace(ia, "").replace(Q, "");
          });
        B(h, function (a, b) {
          !a.inited && !a.map.unnormalized && (a.map = p(b));
        });
        if (a.deps || a.callback) i.require(a.deps || [], a.callback);
      },
      makeShimExports: function (a) {
        return function () {
          var b;
          a.init && (b = a.init.apply(ba, arguments));
          return b || (a.exports && da(a.exports));
        };
      },
      makeRequire: function (a, e) {
        function j(c, d, m) {
          var n, q;
          e.enableBuildCallback && d && G(d) && (d.__requireJsBuild = !0);
          if ("string" === typeof c) {
            if (G(d)) return w(C("requireargs", "Invalid require call"), m);
            if (a && t(L, c)) return L[c](h[a.id]);
            if (g.get) return g.get(i, c, a, j);
            n = p(c, a, !1, !0);
            n = n.id;
            return !t(r, n)
              ? w(
                  C(
                    "notloaded",
                    'Module name "' +
                      n +
                      '" has not been loaded yet for context: ' +
                      b +
                      (a ? "" : ". Use require([])")
                  )
                )
              : r[n];
          }
          J();
          i.nextTick(function () {
            J();
            q = s(p(null, a));
            q.skipMap = e.skipMap;
            q.init(c, d, m, { enabled: !0 });
            D();
          });
          return j;
        }
        e = e || {};
        U(j, {
          isBrowser: z,
          toUrl: function (b) {
            var d,
              e = b.lastIndexOf("."),
              k = b.split("/")[0];
            if (-1 !== e && (!("." === k || ".." === k) || 1 < e))
              (d = b.substring(e, b.length)), (b = b.substring(0, e));
            return i.nameToUrl(c(b, a && a.id, !0), d, !0);
          },
          defined: function (b) {
            return t(r, p(b, a, !1, !0).id);
          },
          specified: function (b) {
            b = p(b, a, !1, !0).id;
            return t(r, b) || t(h, b);
          },
        });
        a ||
          (j.undef = function (b) {
            x();
            var c = p(b, a, !0),
              e = m(h, b);
            d(b);
            delete r[b];
            delete S[c.url];
            delete $[b];
            T(A, function (a, c) {
              a[0] === b && A.splice(c, 1);
            });
            e && (e.events.defined && ($[b] = e.events), y(b));
          });
        return j;
      },
      enable: function (a) {
        m(h, a.id) && s(a).enable();
      },
      completeLoad: function (a) {
        var b,
          c,
          d = m(j.shim, a) || {},
          g = d.exports;
        for (x(); A.length; ) {
          c = A.shift();
          if (null === c[0]) {
            c[0] = a;
            if (b) break;
            b = !0;
          } else c[0] === a && (b = !0);
          E(c);
        }
        c = m(h, a);
        if (!b && !t(r, a) && c && !c.inited) {
          if (j.enforceDefine && (!g || !da(g)))
            return e(a)
              ? void 0
              : w(C("nodefine", "No define call for " + a, null, [a]));
          E([a, d.deps || [], d.exportsFn]);
        }
        D();
      },
      nameToUrl: function (a, b, c) {
        var d, e, h;
        (d = m(j.pkgs, a)) && (a = d);
        if ((d = m(aa, a))) return i.nameToUrl(d, b, c);
        if (g.jsExtRegExp.test(a)) d = a + (b || "");
        else {
          d = j.paths;
          a = a.split("/");
          for (e = a.length; 0 < e; e -= 1)
            if (((h = a.slice(0, e).join("/")), (h = m(d, h)))) {
              H(h) && (h = h[0]);
              a.splice(0, e, h);
              break;
            }
          d = a.join("/");
          d += b || (/^data\:|\?/.test(d) || c ? "" : ".js");
          d =
            ("/" === d.charAt(0) || d.match(/^[\w\+\.\-]+:/) ? "" : j.baseUrl) +
            d;
        }
        return j.urlArgs
          ? d + ((-1 === d.indexOf("?") ? "?" : "&") + j.urlArgs)
          : d;
      },
      load: function (a, b) {
        g.load(i, a, b);
      },
      execCb: function (a, b, c, d) {
        return b.apply(d, c);
      },
      onScriptLoad: function (a) {
        if (
          "load" === a.type ||
          ja.test((a.currentTarget || a.srcElement).readyState)
        )
          (N = null), (a = I(a)), i.completeLoad(a.id);
      },
      onScriptError: function (a) {
        var b = I(a);
        if (!e(b.id))
          return w(C("scripterror", "Script error for: " + b.id, a, [b.id]));
      },
    };
    i.require = i.makeRequire();
    return i;
  }
  var g,
    x,
    y,
    D,
    I,
    E,
    N,
    J,
    s,
    O,
    ka = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/gm,
    la = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
    Q = /\.js$/,
    ia = /^\.\//;
  x = Object.prototype;
  var K = x.toString,
    fa = x.hasOwnProperty,
    ha = Array.prototype.splice,
    z = !!(
      "undefined" !== typeof window &&
      "undefined" !== typeof navigator &&
      window.document
    ),
    ea = !z && "undefined" !== typeof importScripts,
    ja =
      z && "PLAYSTATION 3" === navigator.platform
        ? /^complete$/
        : /^(complete|loaded)$/,
    Y = "undefined" !== typeof opera && "[object Opera]" === opera.toString(),
    F = {},
    q = {},
    R = [],
    M = !1;
  if ("undefined" === typeof define) {
    if ("undefined" !== typeof requirejs) {
      if (G(requirejs)) return;
      q = requirejs;
      requirejs = void 0;
    }
    "undefined" !== typeof require &&
      !G(require) &&
      ((q = require), (require = void 0));
    g = requirejs = function (b, c, d, e) {
      var n,
        p = "_";
      !H(b) &&
        "string" !== typeof b &&
        ((n = b), H(c) ? ((b = c), (c = d), (d = e)) : (b = []));
      n && n.context && (p = n.context);
      (e = m(F, p)) || (e = F[p] = g.s.newContext(p));
      n && e.configure(n);
      return e.require(b, c, d);
    };
    g.config = function (b) {
      return g(b);
    };
    g.nextTick =
      "undefined" !== typeof setTimeout
        ? function (b) {
            setTimeout(b, 4);
          }
        : function (b) {
            b();
          };
    require || (require = g);
    g.version = "2.1.15";
    g.jsExtRegExp = /^\/|:|\?|\.js$/;
    g.isBrowser = z;
    x = g.s = { contexts: F, newContext: ga };
    g({});
    v(["toUrl", "undef", "defined", "specified"], function (b) {
      g[b] = function () {
        var c = F._;
        return c.require[b].apply(c, arguments);
      };
    });
    if (
      z &&
      ((y = x.head = document.getElementsByTagName("head")[0]),
      (D = document.getElementsByTagName("base")[0]))
    )
      y = x.head = D.parentNode;
    g.onError = ca;
    g.createNode = function (b) {
      var c = b.xhtml
        ? document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "html:script"
          )
        : document.createElement("script");
      c.type = b.scriptType || "text/javascript";
      c.charset = "utf-8";
      c.async = !0;
      return c;
    };
    g.load = function (b, c, d) {
      var e = (b && b.config) || {};
      if (z)
        return (
          (e = g.createNode(e, c, d)),
          e.setAttribute("data-requirecontext", b.contextName),
          e.setAttribute("data-requiremodule", c),
          e.attachEvent &&
          !(
            e.attachEvent.toString &&
            0 > e.attachEvent.toString().indexOf("[native code")
          ) &&
          !Y
            ? ((M = !0), e.attachEvent("onreadystatechange", b.onScriptLoad))
            : (e.addEventListener("load", b.onScriptLoad, !1),
              e.addEventListener("error", b.onScriptError, !1)),
          (e.src = d),
          (J = e),
          D ? y.insertBefore(e, D) : y.appendChild(e),
          (J = null),
          e
        );
      if (ea)
        try {
          importScripts(d), b.completeLoad(c);
        } catch (m) {
          b.onError(
            C(
              "importscripts",
              "importScripts failed for " + c + " at " + d,
              m,
              [c]
            )
          );
        }
    };
    z &&
      !q.skipDataMain &&
      T(document.getElementsByTagName("script"), function (b) {
        y || (y = b.parentNode);
        if ((I = b.getAttribute("data-main")))
          return (
            (s = I),
            q.baseUrl ||
              ((E = s.split("/")),
              (s = E.pop()),
              (O = E.length ? E.join("/") + "/" : "./"),
              (q.baseUrl = O)),
            (s = s.replace(Q, "")),
            g.jsExtRegExp.test(s) && (s = I),
            (q.deps = q.deps ? q.deps.concat(s) : [s]),
            !0
          );
      });
    define = function (b, c, d) {
      var e, g;
      "string" !== typeof b && ((d = c), (c = b), (b = null));
      H(c) || ((d = c), (c = null));
      !c &&
        G(d) &&
        ((c = []),
        d.length &&
          (d
            .toString()
            .replace(ka, "")
            .replace(la, function (b, d) {
              c.push(d);
            }),
          (c = (
            1 === d.length ? ["require"] : ["require", "exports", "module"]
          ).concat(c))));
      if (M) {
        if (!(e = J))
          (N && "interactive" === N.readyState) ||
            T(document.getElementsByTagName("script"), function (b) {
              if ("interactive" === b.readyState) return (N = b);
            }),
            (e = N);
        e &&
          (b || (b = e.getAttribute("data-requiremodule")),
          (g = F[e.getAttribute("data-requirecontext")]));
      }
      (g ? g.defQueue : R).push([b, c, d]);
    };
    define.amd = { jQuery: !0 };
    g.exec = function (b) {
      return eval(b);
    };
    g(q);
  }
})(this);

require.config({
  waitSeconds: 0,
  paths: {
    root: ROOT_URL + "/",
    base: ROOT_URL + "/Base/Js/",
    project: ROOT_URL + "/Assets/Js/",
    jquery: ROOT_URL + "/Base/Js/Vendor/JQuery",
    async: ROOT_URL + "/Base/Js/Vendor/Async",
    flickity: ROOT_URL + "/Assets/Js/Vendor/Flickity",
    plyr: ROOT_URL + "/Assets/Js/Vendor/plyr",
    googlemaps: ROOT_URL + "/Assets/Js/Vendor/googlemaps",
    gmaps: ROOT_URL + "/Assets/Js/Vendor/gmaps",
  },
  shim: {
    flickity: ["jquery"],
    plyr: ["jquery"],
    gmaps: ["googlemaps"],
  },
  googlemaps: {
    params: {
      key: "AIzaSyDYkMjM5FMMLi9d3yExxV_e2iK46BRNsfo",
    },
  },
});

var showDebug = false;

require([
  "jquery",
  "root/Base/Js/MbiImageSize",
  "root/Base/Js/MbiMediaQuery",
  "root/Base/Js/MbiBrowser",
  "root/Base/Js/Vendor/PictureFill",
  "root/Assets/Js/Templates",
  "root/Base/Js/MbiLazySizes",
  "root/Base/Js/Vendor/Modernizr" /*,
	'root/Assets/Js/Vendor/cookie'
	*/,
], function ($, mbiImageSize, mbiMq) {
  "use strict";

  // GLOBAL BOOK BUTTON
  var bookVisible = false,
    rotation = 0,
    lastScrollPosition = 0;

  function showGlobalBookMobile() {
    if (window.innerWidth <= 1023 && window.scrollY >= 100 && !bookVisible) {
      $(".global-book").addClass("show");
      bookVisible = true;
    } else if (
      window.innerWidth <= 1023 &&
      window.scrollY <= 99 &&
      bookVisible
    ) {
      $(".global-book").removeClass("show");
      bookVisible = false;
    }
  }
  showGlobalBookMobile();

  function showGlobalBookDesktop() {
    if (window.innerWidth >= 1024) {
      $(".global-book").addClass("show");
    }
  }
  showGlobalBookDesktop();

  function rotateGlobalBook() {
    rotation = parseInt(rotation + (window.scrollY - lastScrollPosition) / 2);
    if (rotation >= 360 || rotation <= -360) {
      rotation = 0;
    }
    lastScrollPosition = window.scrollY;

    $(".global-book").css("transform", "rotate(" + rotation + "deg)");
  }

  document.addEventListener("scroll", function (e) {
    showGlobalBookMobile();
    rotateGlobalBook();
  });

  $(".js_call").on("click", function (e) {
    if ($("html").data("location") === "global") {
      e.preventDefault();
      $(".global-booking-overlay").addClass("open");
      $(".overlay-headline").removeClass("show");
      $(".overlay-headline--tel").addClass("show");
      $(".overlay-button").removeClass("show");
      $(".overlay-button--tel").addClass("show");
    }
  });

  $(".js_book").on("click", function (e) {
    if ($("html").data("location") === "global") {
      e.preventDefault();
      $(".global-booking-overlay").addClass("open");
      $(".overlay-headline").removeClass("show");
      $(".overlay-headline--book").addClass("show");
      $(".overlay-button").removeClass("show");
      $(".overlay-button--book").addClass("show");
    }
  });

  $(".js_close-booking-overlay").on("click", function (e) {
    $(".global-booking-overlay").removeClass("open");
  });

  $('a[href*="quandoo"]').on("click", function (e) {
    if (window.innerWidth >= 1024) {
      e.preventDefault();
      var url = $(this).attr("href");
      window.open(url, "", "left=100,top=100,width=600,height=700,scrollbars");
    }
  });

  $(window).bind("pageshow", function (event) {
    if (event.originalEvent.persisted) {
      window.location.reload();
      $("html").removeClass("siteFadeOut");
    }
  });

  function getScrollBarWidth() {
    var $outer = $("<div>")
        .css({ visibility: "hidden", width: 100, overflow: "scroll" })
        .appendTo("body"),
      widthWithScroll = $("<div>")
        .css({ width: "100%" })
        .appendTo($outer)
        .outerWidth();
    $outer.remove();
    return 100 - widthWithScroll;
  }
  mbiImageSize.init();

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (function () {
      return (
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (
          /* function FrameRequestCallback */ callback,
          /* DOMElement Element */ element
        ) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();
  }

  $(".mainMenu ul li a").each(function (k, el) {
    if (
      $(el).attr("href") == "#mittagstisch" ||
      $(el).attr("href") == "#onlinereservieren"
    ) {
      $(el).parent().addClass("hideOnLandscape");
    }
  });

  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      $("html").removeClass("showMenu");
      $("html").removeClass("showMenuDay");
    }
  });

  $(document).on("click", ".overlay", function (e) {
    if (e.currentTarget == "div.overlay") {
      $("html").removeClass("showMenu");
      $("html").removeClass("showMenuDay");
    }
  });

  $(document).on("click", ".js_pageDown", function () {
    var nextSection = $(this).closest("section").next();
    var offset = nextSection.offset();
    $("body, html").animate(
      {
        scrollTop: offset.top - 60,
      },
      600,
      "swing"
    );
  });

  $(document).on("click", ".js_showAddress", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($("#map").length) {
      $("html, body").animate(
        {
          scrollTop:
            parseInt($("#map").offset().top) - $("header").outerHeight(),
        },
        1400,
        "swing"
      );
    } else {
      var langDomainAppendix = "";
      if (lang == "en") {
        langDomainAppendix = "en/";
      }

      var mapurl =
        "https://meisslundschadn.at/" + langDomainAppendix + "#location";
      window.location = mapurl;
    }
  });

  var scrollbarwidth = getScrollBarWidth();
  $(document).on("click", ".js_showMenu", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("html").addClass("showMenu");
    $("html").addClass("showMenu");
    // console.log($.browser);
    setTimeout(function () {
      $("html").addClass("overflowHidden");
      $("header, .menuList, body").css("padding-right", scrollbarwidth + "px");
    }, 600);
  });

  $(document).on("click", ".js_hideMenu", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("html").removeClass("showMenu");
    setTimeout(function () {
      $("html").removeClass("overflowHidden");
      $("header, .menuList, body").css("padding-right", "");
    }, 600);
  });

  $(document).on("click", ".js_SiteFadeOut", function (e) {
    $("html").removeClass("domLoaded");
    $("html").removeClass("showMenu");
    $("html").removeClass("reachedTop");
    $("html").removeClass("reachedBottom");
    $("html").removeClass("inBetweenScroll");
    $("html").addClass("siteFadeOut");
  });

  var lastPosition =
    (document.documentElement && document.documentElement.scrollTop) ||
    document.body.scrollTop;
  var reachedBottomFirstTime = true;

  function reachedBottom(lastPosition) {
    if (!$("html").hasClass("siteFadeOut")) {
      var body = document.body,
        html = document.documentElement;
      // var height =
      //     Math.max(
      //         body.scrollHeight,
      //         body.offsetHeight,
      //         html.clientHeight,
      //         html.scrollHeight,
      //         html.offsetHeight
      //     ) - $(window).height();

      var height =
        Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        ) - window.innerHeight;

      if (lastPosition < height) {
        $("html").removeClass("reachedBottom");
      } else {
        if (!$(".section-404").length) {
          if (reachedBottomFirstTime) {
            reachedBottomFirstTime = true;
            $("html").addClass("reachedBottom");
          }
        }
      }

      if (lastPosition >= 1) {
        $("html").removeClass("reachedTop");
      } else {
        $("html").addClass("reachedTop");
        $(".global-book").css("transform", "none");
        rotation = 0;
      }

      if (
        !$("html").hasClass("reachedTop") &&
        !$("html").hasClass("reachedBottom")
      ) {
        $("html").addClass("inBetweenScroll");
      } else {
        $("html").removeClass("inBetweenScroll");
      }
    }
  }

  var $introAnimation, fullHeight;
  function introAnimation() {
    $introAnimation = $(".section-introAnimation");
    if ($introAnimation.length && fullHeight !== window.innerHeight) {
      fullHeight = window.innerHeight;
      $introAnimation.css("height", fullHeight + "px");
    }
  }

  var $intro;
  function intro() {
    $intro = $(".section-standortintro");
    fullHeight = window.innerHeight - $("header").outerHeight();
    if (
      window.innerWidth <= 767 &&
      $intro.length &&
      fullHeight !== window.innerHeight
    ) {
      $intro.css("height", fullHeight + "px");
    } else {
      $intro.css("height", "auto");
    }
  }
  intro();

  $(window).resize(function (e) {
    intro();
    showGlobalBookDesktop();
  });

  var loop = function () {
    requestAnimationFrame(loop);

    var check =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;

    if (lastPosition !== check) {
      lastPosition = check;
      reachedBottom(lastPosition);
    }

    introAnimation();
  };

  reachedBottom(lastPosition);
  loop();

  /*
	schnizzle Faces
	*/
  $(".section-schnizzleFace").each(function (k, el) {
    var prevSection = $(el).prev();
    prevSection.addClass("hasSchnizzleFace");
    prevSection.addClass("hasSchnizzleFace_" + $(el).data("id"));
    $(el).appendTo(prevSection);

    switch ($(el).data("id")) {
      case "home10":
        break;
      case "home20":
        break;
    }
  });

  function openOverlay(type) {
    switch (type) {
      case "menuDay":
        $("html").addClass("showMenuDay");
        break;
    }
  }

  $(".menu__item a").each(function (k, el) {
    if ($(el).attr("href") == "#mittagstisch") {
      $(el).addClass("js_showMenuDay");
    }
  });

  $(document).on("click", ".js_showMenuDay", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("html").addClass("showMenuDay");
  });

  $("html").addClass("domLoaded");

  //safari bug
  $(
    ".section-textImageLink.hasSchnizzleFace.hasSchnizzleFace_home10 .text"
  ).text(
    $(
      ".section-textImageLink.hasSchnizzleFace.hasSchnizzleFace_home10 .text"
    ).text()
  );

  require(["gmaps"], function (GMaps) {
    "use strict";

    var map;
    // var gmapsLink = $('.pinLink')[0].href;
    // var gmapsLink;
    var markers = {};

    function initGmaps(e, lat, lng, gmapsLink) {
      if ("portrait-" in mbiMq.mqArea) {
        var drag = false;
        var scrolli = false;
      } else {
        var drag = true;
        var scrolli = false;
      }

      var zoom = 15;
      if ("portrait-" in mbiMq.mqArea) {
        zoom = 14;
      }

      map = new GMaps({
        div: e,
        lat: lat,
        lng: lng,
        zoom: zoom,
        draggable: drag,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: scrolli,
        styles: [
          {
            featureType: "all",
            elementType: "all",
            stylers: [
              {
                saturation: "-27",
              },
            ],
          },
          {
            featureType: "all",
            elementType: "geometry",
            stylers: [
              {
                saturation: "-29",
              },
            ],
          },
          {
            featureType: "all",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-9",
              },
              {
                lightness: "1",
              },
              {
                gamma: "0.82",
              },
            ],
          },
          {
            featureType: "all",
            elementType: "labels",
            stylers: [
              {
                saturation: "-52",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-11",
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [
              {
                hue: "#FFBB00",
              },
              {
                saturation: 43.400000000000006,
              },
              {
                lightness: 37.599999999999994,
              },
              {
                gamma: 1,
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-65",
              },
              {
                lightness: "-2",
              },
            ],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-5",
              },
            ],
          },
          {
            featureType: "landscape.natural.landcover",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-27",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [
              {
                hue: "#00FF6A",
              },
              {
                saturation: -1.0989010989011234,
              },
              {
                lightness: 11.200000000000017,
              },
              {
                gamma: 1,
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#a58955",
              },
              {
                gamma: "1.02",
              },
              {
                lightness: "42",
              },
              {
                saturation: "8",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-31",
              },
              {
                gamma: "0.82",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
              {
                saturation: "-100",
              },
              {
                color: "#a58955",
              },
              {
                weight: "0.24",
              },
              {
                lightness: "5",
              },
              {
                gamma: "0.63",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers: [
              {
                saturation: "-100",
              },
              {
                lightness: "-42",
              },
              {
                weight: "0.56",
              },
              {
                invert_lightness: true,
              },
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                saturation: "-66",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-63",
              },
              {
                color: "#a58955",
              },
              {
                lightness: "36",
              },
              {
                gamma: "1.31",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                lightness: "3",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-54",
              },
              {
                lightness: "-8",
              },
              {
                gamma: "1.00",
              },
              {
                weight: "1.54",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text",
            stylers: [
              {
                saturation: "-5",
              },
              {
                lightness: "-17",
              },
              {
                weight: "0.47",
              },
              {
                color: "#a58955",
              },
              {
                gamma: "0.44",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [
              {
                hue: "#FFC200",
              },
              {
                saturation: -61.8,
              },
              {
                lightness: 45.599999999999994,
              },
              {
                gamma: 1,
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "all",
            stylers: [
              {
                hue: "#FF0300",
              },
              {
                saturation: -100,
              },
              {
                lightness: 51.19999999999999,
              },
              {
                gamma: 1,
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "all",
            stylers: [
              {
                hue: "#FF0300",
              },
              {
                saturation: -100,
              },
              {
                lightness: 52,
              },
              {
                gamma: 1,
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "labels",
            stylers: [
              {
                saturation: "-100",
              },
              {
                lightness: "23",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              {
                hue: "#0078FF",
              },
              {
                saturation: -13.200000000000003,
              },
              {
                lightness: 2.4000000000000057,
              },
              {
                gamma: 1,
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
              {
                saturation: "-16",
              },
              {
                lightness: "-4",
              },
              {
                gamma: "0.72",
              },
            ],
          },
        ],
      });

      google.maps.event.addDomListener(window, "resize", function () {
        map.panTo({ lat: lat, lng: lng });
      });

      var image = {
        url: ASSETS_URL + "/Images/pin.png",
      };

      var marker = {
        lat: lat,
        lng: lng,
        icon: image,
        url: gmapsLink,
        click: function (e) {
          window.open(gmapsLink, "_blank");
        },
      };
      map.addMarker(marker);
    }

    if ($(".gmap").length != 0) {
      $(".gmap").each(function (key, value) {
        var e = "gmap-" + key;
        var lat = $(value).data("lat");
        var lng = $(value).data("lng");
        var gmapsLink = $(value).data("pinlink");
        initGmaps(e, lat, lng, gmapsLink);
      });
    }
  });
});

window.onload = function () {
  // geo position
  var isDesktopBrowser = false;
  var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf("android") > -1;
  var isWindowsPhone = false;
  if (navigator.userAgent.match(/Windows Phone/i)) {
    isWindowsPhone = true;
  }

  if (navigator.userAgent.match(/iemobile/i)) {
    isWindowsPhone = true;
  }
  if (navigator.userAgent.match(/WPDesktop/i)) {
    isWindowsPhone = true;
  }

  var md = new Date();
  var mn = md.getHours();

  var langDomainAppendix = "";
  if (lang == "en") {
    langDomainAppendix = "en/";
  }

  var domainPrefix = "https://meisslundschadn.at/" + langDomainAppendix;
  if (window.location.hostname == "localhost") {
    domainPrefix =
      "http://localhost/MeisslundschadnbigsiteAt/" + langDomainAppendix;
  }

  function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo];
  }

  var weekNumberArray = getWeekNumber(new Date());

  //Get the latitude and the longitude;
  function successFunction(position) {
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    console.log("success getCurrentPosition");
    if (showDebug) {
      alert("successFunction " + lat);
    }
    codeLatLng(lat, lng);
  }

  function errorFunction(error) {
    console.log("error getCurrentPosition");
    if (showDebug) {
      alert("Geocoder failed");
      alert(error.code);
      alert(error.message);
    }
  }

  function codeLatLng(lat, lng) {
    var latlng = new google.maps.LatLng(lat, lng);
    geocoder.geocode({ latLng: latlng }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          var iterate = true;
          $.each(results, function (k, el) {
            $.each(el.address_components, function (p, part) {
              if (iterate) {
                if (part.long_name == "Wien") {
                  city = part.long_name;
                }
                if (part.long_name == "Vienna") {
                  city = part.long_name;
                }
              }
            });
          });
        }
      }
    });
  }

  $(".js_open-submenu").on("click", function () {
    var transitionDuration = 500;

    var $currentSubmenuPanel = $(this).next(".menu__submenu-panel");
    var $currentSubmenu = $currentSubmenuPanel.find(".menu__items");

    var $otherSubmenuPanels = $(".menu__submenu-panel").not(
      $currentSubmenuPanel
    );
    var $otherSubmenus = $otherSubmenuPanels.find(".menu__items");

    if ($currentSubmenu.hasClass("open")) {
      // * close submenu
      $(this).attr("aria-expanded", "false");
      $currentSubmenu.removeClass("open");
      setTimeout(function () {
        $currentSubmenuPanel.attr("hidden", "");
      }, transitionDuration);
    } else {
      // * close all others
      $(".js_open-submenu").attr("aria-expanded", "false");
      $otherSubmenus.removeClass("open");
      setTimeout(function () {
        $otherSubmenuPanels.attr("hidden", "");
      }, transitionDuration);
      // * open submenu
      $currentSubmenuPanel.removeAttr("hidden");
      setTimeout(function () {
        $(this).attr("aria-expanded", "true");
        $currentSubmenu.addClass("open");
      }, 10);
    }
  });

  $(".menu__entry--current").parents(".menu__level1").addClass("open");

  // IFRAME ACCORDION (CONNECTOOR)

  const contentModule = $("ul.accordion");

  if (contentModule.length) {
    const accordionPanels = $(".accordion__panel-wrapper");
    const resize = contentModule.data("resize");

    function accordionHeight(accordionPanels) {
      console.log("accordionHeight");
      if (accordionPanels.length) {
        console.log("accordionHeight II");
        accordionPanels.each(function () {
          console.log("accordionHeight III)");
          console.log($(this));
          $(this).css(
            "max-height",
            $(this).children(".accordion__panel").outerHeight() + "px"
          );
        });
      }
    }

    if (resize !== false) {
      accordionHeight(accordionPanels);

      $(window).on("resize", function () {
        accordionHeight(accordionPanels);
      });
    }

    // open/close
    $(document).on("click", ".js_accordion__button", function (e) {
      let currentItem = $(this).parents(".accordion__item");
      let currentHeader = $(this);
      let currentPanel = currentItem.find(".accordion__panel-wrapper");
      let expanded = currentHeader.attr("aria-expanded");

      let accordionItems = $(this)
        .parents(".accordion")
        .find(".accordion__item");
      let accordionHeaders = accordionItems.find(".accordion__button");
      let accordionPanels = accordionItems.find(".accordion__panel-wrapper");

      accordionHeaders.attr("aria-expanded", "false");
      accordionPanels.attr("aria-hidden", "true");

      if (expanded === "false") {
        currentHeader.attr("aria-expanded", "true");
        currentPanel.attr("aria-hidden", "false");
      }

      setTimeout(() => {
        $("html, body").animate({
          scrollTop: parseInt(currentItem.offset().top) - 90,
        });
      }, 300);
    });
  }

  // HIGH CONTRAST THEME

  /**
   * Determines the user's preferred theme based on their system's contrast settings.
   *
   * @returns {string} Returns 'high-contrast' if the user prefers more contrast, otherwise 'default'.
   */
  function getPreferedTheme() {
    return window.matchMedia("(prefers-contrast: more)").matches
      ? "high-contrast"
      : "default";
  }

  /**
   * Sets the color theme for the website by updating the 'data-theme' attribute on the <html> element.
   *
   * @param {'default' | 'high-contrast'} theme - The color theme to apply. Accepts either 'default' or 'high-contrast'.
   */
  function setColorTheme(theme) {
    $("html").attr("data-theme", theme);
  }

  function saveColorTheme(theme) {
    localStorage.setItem("colorTheme", theme);
  }

  const savedTheme = localStorage.getItem("colorTheme");
  const theme = savedTheme || getPreferedTheme();

  setColorTheme(theme);

  function toggleColorTheme() {
    const currentTheme = $("html").attr("data-theme");
    const newTheme = currentTheme === "default" ? "high-contrast" : "default";

    setColorTheme(newTheme);
    saveColorTheme(newTheme);
  }

  $(document).on("click", ".js_toggle-high-contrast", function (e) {
    e.preventDefault();
    toggleColorTheme();
  });
};

define("Assets/Js/Footer.js", function(){});

